// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1Metadata } from './V1Metadata';
import {
  V1MetadataFromJSON,
  V1MetadataFromJSONTyped,
  V1MetadataToJSON,
  V1MetadataToJSONTyped,
} from './V1Metadata';
import type { V1ClusterSpec } from './V1ClusterSpec';
import {
  V1ClusterSpecFromJSON,
  V1ClusterSpecFromJSONTyped,
  V1ClusterSpecToJSON,
  V1ClusterSpecToJSONTyped,
} from './V1ClusterSpec';
import type { V1ClusterStatus } from './V1ClusterStatus';
import {
  V1ClusterStatusFromJSON,
  V1ClusterStatusFromJSONTyped,
  V1ClusterStatusToJSON,
  V1ClusterStatusToJSONTyped,
} from './V1ClusterStatus';

/**
 *
 * @export
 * @interface V1Cluster
 */
export interface V1Cluster {
  /**
   *
   * @type {V1Metadata}
   * @memberof V1Cluster
   */
  metadata?: V1Metadata;
  /**
   *
   * @type {V1ClusterSpec}
   * @memberof V1Cluster
   */
  spec?: V1ClusterSpec;
  /**
   *
   * @type {V1ClusterStatus}
   * @memberof V1Cluster
   */
  status?: V1ClusterStatus;
}

/**
 * Check if a given object implements the V1Cluster interface.
 */
export function instanceOfV1Cluster(value: object): value is V1Cluster {
  return true;
}

export function V1ClusterFromJSON(json: any): V1Cluster {
  return V1ClusterFromJSONTyped(json, false);
}

export function V1ClusterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Cluster {
  if (json == null) {
    return json;
  }
  return {
    metadata:
      json['metadata'] == null
        ? undefined
        : V1MetadataFromJSON(json['metadata']),
    spec:
      json['spec'] == null ? undefined : V1ClusterSpecFromJSON(json['spec']),
    status:
      json['status'] == null
        ? undefined
        : V1ClusterStatusFromJSON(json['status']),
  };
}

export function V1ClusterToJSON(json: any): V1Cluster {
  return V1ClusterToJSONTyped(json, false);
}

export function V1ClusterToJSONTyped(
  value?: V1Cluster | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    metadata: V1MetadataToJSON(value['metadata']),
    spec: V1ClusterSpecToJSON(value['spec']),
    status: V1ClusterStatusToJSON(value['status']),
  };
}
